import React, { Component, useState, useEffect } from "react";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "utils/db";
import PageHeader from 'components/form/PageHeader'
import { NotifyAlertRow } from 'components/ui/rows/NotifyAlertRow'
import { DataHelper } from 'utils/DataHelper';
import { Button } from 'react-bootstrap'
import { useNavigate } from "react-router-dom";
import { motion } from 'framer-motion'
import { Container } from 'react-bootstrap'


export function NotifyAlertListing() {

    let navigate = useNavigate();

    const [searchInput, setSearchInput] = useState('');
    const [filterInput, setFilterInput] = useState('');

    const [filteredResults, setFilteredResults] = useState([]);

    useEffect(() => {
        setFilteredResults(NotifyAlerts);
    }, []);

    const NotifyAlerts = useLiveQuery(() => db.notifyalerts.where("deleted").equals(0).toArray());


    if (!NotifyAlerts) return null;

    function addNewNotifyAlert (){
         navigate("/NotifyAlertedit");
    }


    const filterNotifyAlerts = (selected) => {
        setFilterInput(selected.target.value);
        const filter = selected.target.value;
        searchItems(searchInput, filter);
    }


    const searchItems = (searchValue, filter = "-") => {
        setSearchInput(searchValue)
        const filteredData = [];

        if (filter == "-") filter = filterInput;
        if (filter == "*") filter = "";


        for (let i = 0; i < NotifyAlerts.length; i++) {
            const item = JSON.parse(NotifyAlerts[i].contents);
            const NotifyAlert = NotifyAlerts[i];

            if (searchValue == "" || item.title.toLowerCase().includes(searchValue.toLowerCase())
                || item.rule.toLowerCase().includes(searchValue.toLowerCase()))
            {
                if (NotifyAlert.deleted == 0) {
                    filteredData.push(NotifyAlert);
                }
            }
        }
        setFilteredResults(filteredData)
 
    }

    return (
        <Container>
            <motion.div className="page-header-section"
        >
           <PageHeader pageName={"NotifyAlerts"} showTime={false} />
                <div className="NotifyAlertSearch">
                <div className="row">
                    <div className="input-group-filter col-md-6">
                        <input type="text" className="form-control" placeholder="Search for..." aria-label="Filter" aria-describedby="basic-addon1" onChange={(e) => searchItems(e.target.value)} />
                    </div>
                    <div className="col-md-3">
                        <div className="btn btn-primary" onClick={() => addNewNotifyAlert() }><i className="bi bi-plus-lg"></i>Add</div>
                    </div>
                </div>
            </div>


            {searchInput.length > 0 || filterInput.length > 0 ?  (

                    filteredResults.map(item => (
                        <NotifyAlertRow item={item} key={item.id} />
                    ))

                ) : (
                    NotifyAlerts.map(item => (
                        <NotifyAlertRow item={item} key={item.id} />
                    ))
                )
                }
            
            </motion.div>
        </Container>
    );

}


